import { Button, type ButtonProps } from './ui/button';
import { useToast } from './ui/use-toast';

type Props = ButtonProps & {
  shareData?: Omit<ShareData, 'url'>;
  getUrl?: () => string;
};

export function SharePageButton({ shareData, getUrl, children, ...ButtonProps }: Props) {
  const toast = useToast();

  const handleShare = async () => {
    // the `src` searchParam is for back navigation and should be omitted when
    // sharing
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('src');
    const fallbackUrl = currentUrl.toString();

    const data = {
      text: "Let's Roll! Check out this Fighters Passport page",
      url: getUrl ? getUrl() : fallbackUrl,
      ...shareData,
    };

    if (typeof navigator.canShare === 'function' && navigator.canShare(data)) {
      navigator.share(data);
    } else {
      copyUrl();
    }
  };

  const copyUrl = () => {
    navigator.clipboard.writeText(getUrl ? getUrl() : window.location.href);

    toast.toast({
      // id: 'copy-toast',
      title: 'Success!',
      description: 'Link copied to clipboard',
    });
  };

  return (
    <Button onClick={handleShare} {...ButtonProps}>
      {children ?? 'Share'}
    </Button>
  );
}
